import gql from "graphql-tag"

export const VERCEL_ADDED_SUBSCRIPTION = gql`
  subscription nowAdded($siteId: UUID!) {
    nowIntegrationAdded(siteId: $siteId)
  }
`
